module.exports = __webpack_public_path__ + "static/img/bar-background.4576cd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bar-background.png
// module id = D0Vt
// module chunks = 15